const API_URL = 'https://web1c3.ent-en.com/hrmcorp/hs/api';
const API_username = 'lk_api_user';
const API_password = 'Mi6ka1vyMi6ka1vy';
const DADATA_API_token = '998d18a2fe0eecd6897b1331f074007d47f34131';

//Nikitin_HRM_CORP_REGL
//Korostelev_HRM lk_api_user cA3xi9xe
//Vasin_HRM_Corp
//Havalov_HRM_Corp lk_api_user cA8mopos
//https://web1c3.ent-en.com/hrmcorp/hs/api lk_api_user Mi6ka1vyMi6ka1vy
//Nikolaev_EE_HRM_CORP_REGL
//http://192.168.11.89/PreProd_ENTER_regl/hs/api lk_api_user Mi6ka1vyMi6ka1vy

export {API_URL, API_username, API_password, DADATA_API_token};